import { useState, useEffect } from "react";

export default function GenerateTrial() {

  const randomItem = (list) => {
    return list[Math.floor(Math.random() * list.length)];
  };

  const goodThingList  = [
    "自販機で当たりが出た",
    "水を買ったら小っちゃい水が当たった",
    "ラーメンの替え玉が無料だった",
    "コンビニで好きなお菓子が最後の一個だった",
    "信号が全部青だった",
    "電車で座れた",
    "レジでちょうど小銭を使い切れた",
    "冷蔵庫を開けたらプリンが残ってた",
    "ポケットから忘れていた500円が出てきた",
    "雨が降り始める直前に家に着いた",
    "遅刻すると思ったら間に合った",
  ];

  const styleList = [
    "manga",
    "anime",
    "watercolor",
    "oil_painting",
    "pixel_art",
    "line_art",
  ];


  const worldList = [
    "none",
    "realistic",
    "fantasy",
    "japanese",
    "chinese",
    "3d_render",
    "ghibli",
    "cyberpunk",
    "dark_fantasy",
    "sci_fi",
  ];

  const sceneryList = [
    "none",
    "ocean",
    "city",
    "forest",
    "cafe",
    "park",
    "night_sky",
    "sunset",
  ];

  const nameList = [
    "アオイ",
    "ハル",
    "ナギ",
    "ソラ",
    "ユイ",
    "レン",
    "カナタ",
    "ミオ",
    "コハク",
    "ルカ",
  ];

  const genderList = [
    "female",
    "male",
    "androgynous",
  ];

  const ageList = [
    "teen_young_adult",
    "young_adult",
    "middle_adult",
    "mature_adults",
    "senior_adult",
    "elder_adult",
    "elderly",
  ];

  const characterStyleList = [
    "manga",
    "anime",
    "watercolor",
    "oil_painting",
    "Ukiyo-e",
    "3d_render",
    "ghibli",
    "pixel_art",
    "line_art",
  ];

  const characterWorldList = [
    "none",
    "fantasy",
    "realistic",
    "cyberpunk",
    "dark_fantasy",
    "sci_fi",
    "dark",
    "epic",
    "japanese",
    "nostalgic",
    "magical",
  ];

  const roleList = [
    "none",
    "protagonist",
    "rival",
    "heroine",
    "villain",
    "partner",
    "mentor",
    "final_boss",
    "guide",
    "wanderer",
    "guardian",
  ];

  const costumeList = [
    "none",
    "casual",
    "school_uniform",
    "fantasy_robe",
    "suit",
    "kimono",
    "idol",
    "labcoat",
    "military",
    "adventurer",
    "mage",
  ];

  const hairstyleList = [
    "none",
    "short_hair",
    "long_hair",
    "bob_cut",
    "ponytail",
    "twin_tails",
    "wavy_hair",
    "straight_hair",
    "messy_hair",
    "wolf_cut",
  ];

  const expressionList = [
    "none",
    "smile",
    "gentle_smile",
    "cool",
    "happy",
    "shy",
    "surprised",
    "sad",
    "angry",
    "mysterious",
    "sleepy",
  ];

  const poseList = [
    "none",
    "standing",
    "sitting",
    "looking_back",
    "arms_crossed",
    "looking_up",
  ];

  const colorList = [
    "#ffb347", // オレンジ
    "#ff6b6b", // 赤
    "#ffd93d", // 黄色
    "#6bcB77", // 緑
    "#4dabf7", // 青
    "#9b59b6", // 紫
    "#ff8fc7", // ピンク
  ];



  const [formData, setFormData] = useState({
    title: randomItem(goodThingList),
    size: "1024x1024",

    style: randomItem(styleList),

    color: randomItem(colorList),

    scenery: randomItem(sceneryList),

    world: randomItem(worldList),

    name: randomItem(nameList),
    age: randomItem(ageList),
    gender: randomItem(genderList),

    role: randomItem(roleList),
    costume: randomItem(costumeList),
    hairstyle: randomItem(hairstyleList),
    expression: randomItem(expressionList),
    pose: randomItem(poseList),

  });





  const [mode, setMode] = useState("illustration");


  

  const [globalPoints, setGlobalPoints]
    = useState(3000);

  const [remainingImages,
    setRemainingImages]
    = useState(30);

  const percent = (globalPoints / 3000) * 100;

  const isFinished =
  globalPoints <= 0 ||
  remainingImages <= 0;

  useEffect(() => {
    fetch("https://anymo-site.com/api/images/status/")
      .then(res => {
        console.log("status", res.status);
        return res.json();
      })
      .then(data => {
        console.log("data", data);

        setRemainingImages(data.remaining);
        setGlobalPoints(data.points);
      })
      .catch(err => {
        console.error("fetch error", err);
      });
  }, []);


  // 入力変更
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  

  const [errorMessage, setErrorMessage]
    = useState("");


  // 送信

  // 送信
  const handleSubmit = async (e) => {
    e.preventDefault();

    setProgress(0);
    setSeconds(0);

    setLoading(true);
    setErrorMessage("");

    try {
      const response = await fetch(
        "https://anymo-site.com/api/images/",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRFToken": getCookie("csrftoken"),
          },
          body: JSON.stringify(payload),
        }
      );

      const text = await response.text();
      console.log("status", response.status);
      console.log("response", text);

      // JSONに変換
      const data = JSON.parse(text);

      // エラー処理
      if (!response.ok || data.error) {

        if (data.error === "daily_limit_exceeded") {
          window.location.href =
          `https://anymo-site.com/free_images_limit/${trialUserId}/`;
          return;
        }

        setErrorMessage(data.error || "エラーが発生しました");
        setLoading(false);
        return;
      }

      
      setProgress(100);

      requestAnimationFrame(() => {
        setTimeout(() => {
          window.location.href =
          `https://anymo-site.com/free_images_confirm/${trialUserId}/`;
        }, 1000);
      });
      



    } catch (error) {
      console.error(error);
      setErrorMessage("通信エラーです");
      setLoading(false);
    }
  };

 

  

  // csrf取得
  const getCookie = (name) => {
    let cookieValue = null;

    if (document.cookie && document.cookie !== "") {
      const cookies = document.cookie.split(";");

      for (let cookie of cookies) {
        cookie = cookie.trim();

        if (cookie.startsWith(name + "=")) {
          cookieValue = decodeURIComponent(
            cookie.substring(name.length + 1)
          );
          break;
        }
      }
    }

    return cookieValue;
  };

  console.log(getCookie("csrftoken"));

  let trialUserId =
    localStorage.getItem(
      "trial_user_id"
    );

  if (!trialUserId) {

    trialUserId =
      crypto.randomUUID();

    localStorage.setItem(
      "trial_user_id",
      trialUserId
    );

  }

  const payload = {

    ...formData,

    trial_user_id:
    trialUserId,
    mode: mode,

  };

  const [showDetails, setShowDetails]
  = useState(false);

  const loadingMessages = [
    "色を混ぜています...",
    "世界を生成しています...",
    "AIが描いています...",
    "光を配置しています...",
    "雲を浮かべています...",
    "最後の仕上げ中です..."
  ];

  const [messageIndex, setMessageIndex]
    = useState(0);

  useEffect(() => {

    const interval = setInterval(() => {

      setMessageIndex(prev =>
        (prev + 1) %
        loadingMessages.length
      );

    }, 2500);

    return () =>
      clearInterval(interval);

  }, []);

  const [progress, setProgress] = useState(0);
  const [seconds, setSeconds] = useState(0);
  const [loading, setLoading]
    = useState(false);

  useEffect(() => {

  if (!loading) return;

  const timer = setInterval(() => {

    setSeconds(prev => prev + 1);

    setProgress(prev => {

      if (prev < 99) {
        return prev + Math.random() * 5;
      }

      return prev;

    });

  }, 700);

  return () => clearInterval(timer);

}, [loading]);

  if (loading) {

      return (

        <div class="free_image_root overWrap">

            <div
            className="loading-container"
          >


            <div className="loading-text">
              <span>
                {loadingMessages[messageIndex]}
              </span>
            </div>


            <div className="spinner_box">
              <div className="spinner_outer">
                <div className="spinner">
                  <div className="spinner_inner"></div>
                </div>
              </div>
            </div>


            <div className="loading_box">

              <div className="progress_bar">
                <div
                  className="progress_fill"
                  style={{
                    width: `${Math.min(progress, 100)}%`
                  }}
                />
              </div>

              <div>{Math.floor(progress)}%</div>

            </div>

            

          </div>

        </div>

        

      );
    }

  return (

    <div class="free_image_root">

        <div className="container">



      <h2 className="free_try_tyle">エニモンクリエイト｜今日の一枚  （無料トライアル）</h2>


    

      <div className="free_mode_btns">
        <button
          className={
              mode === "illustration"
                ? "active_btn left"
                : "left"
            }
            onClick={() => setMode("illustration")}
          >
          イラスト生成
        </button>

        <button
          className={
              mode === "character"
                ? "active_btn right"
                : "right"
            }
            onClick={() => setMode("character")}
          >
          キャラ生成
        </button>

      </div>

      {mode === "illustration" && (
        <form  onSubmit={handleSubmit}>

          {/* タイトル */}
          <div>
            <label className="free_try_label">お題:今日見つけたよかったこと</label>
            <div >
              <input
              className="free_try_input"
              type="text"
              name="title"
              placeholder="今日見つけたよかったこと"
              maxLength={30}
              value={formData.title}
              onChange={handleChange}
            />
            </div>
          </div>

          <div className="form_inputs">

              <div className="field">
                <label className="free_try_label">スタイル</label>
                <div>
                  <select
                  className="free_try_select"
                  name="style"
                  value={formData.style}
                  onChange={handleChange}
                  >

                  <option value="manga">
                    漫画
                  </option>

                  <option value="anime">
                    アニメ
                  </option>

                  <option value="watercolor">
                    水彩画
                  </option>

                  <option value="oil_painting">
                    油絵
                  </option>

                  <option value="pixel_art">
                    ピクセルアート
                  </option>

                  <option value="line_art">
                    線画
                  </option>

                </select>


                </div>
              
              </div>

              <div className="field">
                <label className="free_try_label">世界観</label>

                <div>
                  <select
                  className="free_try_select"
                  name="world"
                  value={formData.world}
                  onChange={handleChange}
                >
                  <option value="none">なし</option>

                  <option value="realistic">
                    リアル
                  </option>

                  <option value="fantasy">
                    ファンタジー
                  </option>

                  <option value="japanese">
                    和風
                  </option>

                  <option value="chinese">
                    中華
                  </option>

                  <option value="3d_render">
                    3D
                  </option>

                  <option value="ghibli">
                    ジブリ風
                  </option>

                  <option value="cyberpunk">
                    サイバーパンク
                  </option>

                  <option value="dark_fantasy">
                    ダークファンタジー
                  </option>

                  <option value="sci_fi">
                    SF
                  </option>

                </select>
                </div>
                
              </div>

              <div className="field">

                <label className="free_try_label">景色</label>

                <div>
                  <select
                  name="scenery"
                  value={formData.scenery}
                  onChange={handleChange}
                >

                  <option value="none">なし</option>

                  <option value="ocean">
                    海辺
                  </option>

                  <option value="city">
                    都市
                  </option>

                  <option value="forest">
                    森林
                  </option>

                  <option value="cafe">
                    カフェ
                  </option>

                  <option value="park">
                    公園
                  </option>

                  <option value="night_sky">
                    夜空
                  </option>

                  <option value="sunset">
                    夕焼け
                  </option>

                </select>

                </div>

              </div>

            <div className="field">
                <label className="free_try_label">性別</label>
                <div>
                  <select
                  className="free_try_select"
                  name="gender"
                  value={formData.gender}
                  onChange={handleChange}
                  required
                  >

                  <option value="female">
                    女性
                  </option>

                  <option value="male">
                    男性
                  </option>

                  <option value="androgynous">
                    中性的
                  </option>


                </select>


                </div>
              
              </div>

            <div className="field color_field">

              <label className="free_try_label">
                カラー
              </label>

              <div>

                <input
                  type="color"
                  className="free_try_color"
                  name="color"
                  value={formData.color}
                  onChange={handleChange}
                />

              </div>

            </div>

            

          </div>

          <div className="submitBtn">
            <button className="btn-square-so-pop" type="submit">
            クリエイトする＞
          </button>
          </div>

        </form>
      )}



      {mode === "character" && (
        <form  onSubmit={handleSubmit}>

          <div>
                <label className="free_try_label">
                  キャラクター（エニモン）の名まえ（任意）
                  </label>
                <div >
                  <input
                  className="free_try_input"
                  type="text"
                  name="name"
                  placeholder="名前でキャラクターのイメージも変わります。好きな名前を付けてみましょう！"
                  maxLength={30}
                  value={formData.name}
                  onChange={handleChange}
                />
                </div>
          </div>

          <div className="form_inputs character_inputs">

              

              <div className="field">
                <label className="free_try_label">性別</label>
                <div>
                  <select
                  className="free_try_select"
                  name="gender"
                  value={formData.gender}
                  onChange={handleChange}
                  required
                  >

                  <option value="female">
                    女性
                  </option>

                  <option value="male">
                    男性
                  </option>

                  <option value="androgynous">
                    中性的
                  </option>


                </select>


                </div>
              
              </div>

              <div className="field">
                <label className="free_try_label">年代</label>
                <div>
                  <select
                  className="free_try_select"
                  name="age"
                  value={formData.age}
                  onChange={handleChange}
                  required
                  >

                  <option value="teen_young_adult">
                    10代〜20代
                  </option>

                  <option value="young_adult">
                    20代〜30代
                  </option>

                  <option value="middle_adult">
                    30代〜40代
                  </option>

                  <option value="mature_adults">
                    40代〜50代
                  </option>

                  <option value="senior_adult">
                    60代〜70代
                  </option>

                  <option value="elder_adult">
                    70代〜80代
                  </option>

                  <option value="elderly">
                    80代以上
                  </option>

                </select>


                </div>
              
              </div>



              <div className="field">
                <label className="free_try_label">
                  スタイル（任意）
                  </label>
                <div>
                  <select
                  className="free_try_select"
                  name="style"
                  value={formData.style}
                  onChange={handleChange}
                  >

                  <option value="manga">
                    漫画
                  </option>

                  <option value="anime">
                    アニメ
                  </option>

                  <option value="watercolor">
                    水彩画
                  </option>

                  <option value="oil_painting">
                    油絵
                  </option>

                  <option value="Ukiyo-e">
                    浮世絵
                  </option>

                  <option value="3d_render">
                    3D
                  </option>

                  <option value="ghibli">
                    ジブリ風
                  </option>

                  <option value="pixel_art">
                    ピクセルアート
                  </option>

                  <option value="line_art">
                    線画
                  </option>

                </select>


                </div>
              
              </div>

              <div className="field">
                <label className="free_try_label">
                  世界観（任意）
                </label>

                <div>
                  <select
                  className="free_try_select"
                  name="world"
                  value={formData.world}
                  onChange={handleChange}
                >
                  <option value="none">なし</option>

                  <option value="fantasy">
                    ファンタジー
                  </option>

                  <option value="realistic">
                    リアル
                  </option>

                  <option value="cyberpunk">
                    サイバーパンク
                  </option>

                  <option value="dark_fantasy">
                    ダークファンタジー
                  </option>

                  <option value="sci_fi">
                    SF
                  </option>

                  <option value="dark">
                    ダーク
                  </option>

                  <option value="epic">
                    英雄譚
                  </option>

                  <option value="japanese">
                    和風
                  </option>

                  <option value="nostalgic">
                    ノスタルジック
                  </option>

                  <option value="magical">
                    魔法世界
                  </option>

                </select>
                </div>
                
              </div>


            <button className="detail_fields_btn"
              type="button"
              onClick={() =>
                setShowDetails(!showDetails)
              }
            >
              {showDetails
                ? "▲ 詳細設定を閉じる"
                : "▼ 詳細設定（任意）"
              }
            </button>


            {showDetails && (
              <div className="detail_fields">

                <div className="field">

                    <label className="free_try_label">
                      役割（任意）
                    </label>

                    <div>
                        <select
                        name="role"
                        value={formData.role}
                        onChange={handleChange}
                      >

                        <option value="none">なし</option>

                        <option value="protagonist">
                          主人公
                        </option>

                        <option value="rival">
                          ライバル
                        </option>

                        <option value="heroine">
                          ヒロイン
                        </option>

                        <option value="villain">
                          悪役
                        </option>

                        <option value="partner">
                          相棒
                        </option>

                        <option value="mentor">
                          師匠
                        </option>

                        <option value="final_boss">
                          ラスボス
                        </option>

                        <option value="guide">
                          案内役
                        </option>

                        <option value="wanderer">
                          放浪者
                        </option>

                        <option value="guardian">
                          守護者
                        </option>


                      </select>

                    </div>

                </div>　

                <div className="field">

                    <label className="free_try_label">
                      服装（任意）
                    </label>

                    <div>
                        <select
                        name="costume"
                        value={formData.costume}
                        onChange={handleChange}
                      >

                        <option value="none">なし</option>

                        <option value="casual">
                          カジュアル
                        </option>

                        <option value="school_uniform">
                          学生服
                        </option>

                        <option value="fantasy_robe">
                          ファンタジーローブ
                        </option>

                        <option value="suit">
                          スーツ
                        </option>

                        <option value="kimono">
                          和服
                        </option>

                        <option value="idol">
                          アイドル衣装
                        </option>

                        <option value="labcoat">
                          白衣
                        </option>

                        <option value="military">
                          ミリタリー
                        </option>

                        <option value="adventurer">
                          冒険者
                        </option>

                        <option value="mage">
                          魔法使い
                        </option>


                      </select>

                    </div>

                </div>　　

                <div className="field">

                    <label className="free_try_label">
                      髪型（任意）
                    </label>

                    <div>
                        <select
                        name="hairstyle"
                        value={formData.hairstyle}
                        onChange={handleChange}
                      >

                        <option value="none">なし</option>

                        <option value="short_hair">
                          ショート
                        </option>

                        <option value="long_hair">
                          ロング
                        </option>

                        <option value="bob_cut">
                          ボブ
                        </option>

                        <option value="ponytail">
                          ポニーテール
                        </option>

                        <option value="twin_tails">
                          ツインテール
                        </option>

                        <option value="wavy_hair">
                          ウェーブ
                        </option>

                        <option value="straight_hair">
                          ストレート
                        </option>

                        <option value="messy_hair">
                          くせ毛
                        </option>

                        <option value="wolf_cut">
                          ウルフカット
                        </option>


                      </select>

                    </div>

                </div>　

                <div className="field">

                    <label className="free_try_label">
                      表情（任意）
                    </label>

                    <div>
                        <select
                        name="expression"
                        value={formData.expression}
                        onChange={handleChange}
                      >

                        <option value="none">なし</option>

                        <option value="smile">
                          笑顔
                        </option>

                        <option value="gentle_smile">
                          優しい微笑み
                        </option>

                        <option value="cool">
                          クール
                        </option>

                        <option value="happy">
                          元気
                        </option>

                        <option value="shy">
                          照れ顔
                        </option>

                        <option value="surprised">
                          驚き
                        </option>

                        <option value="sad">
                          悲しげ
                        </option>

                        <option value="angry">
                          怒り
                        </option>

                        <option value="mysterious">
                          ミステリアス
                        </option>

                        <option value="sleepy">
                          眠そう
                        </option>


                      </select>

                    </div>

                </div>　

                <div className="field">

                    <label className="free_try_label">
                      ポーズ（任意）
                    </label>

                    <div>
                        <select
                        name="pose"
                        value={formData.pose}
                        onChange={handleChange}
                      >

                        <option value="none">なし</option>

                        <option value="standing">
                          立ち姿
                        </option>

                        <option value="sitting">
                          座る
                        </option>

                        <option value="looking_back">
                          振り向く
                        </option>

                        <option value="arms_crossed">
                          腕組み
                        </option>

                        <option value="looking_up">
                          空を見上げる
                        </option>


                      </select>

                    </div>

                </div>　

                <div className="field ">

                  <label className="free_try_label">
                    カラー（任意）
                  </label>

                  <div>

                    <input
                      type="color"
                      className="free_try_color"
                      name="color"
                      value={formData.color}
                      onChange={handleChange}
                    />

                  </div>

                </div>


              </div>
            )}


           


          </div>

          <div className="submitBtn">
            <button className="btn-square-so-pop" type="submit">
            クリエイトする＞
          </button>
          </div>

        </form>
      )}

      

      

      <div className="point_box">

        <div className="point_header">

          <h3>
            本日の無料生成ポイント
          </h3>

          <span>
            {globalPoints} pt
          </span>

        </div>

        <div className="gauge_bg">

          <div
            className="gauge_fill"
            style={{
              width: `${percent}%`
            }}
          />

        </div>

        <p>
          残り生成枚数：
          {remainingImages} 枚：
        </p>


      </div>
      </div>

    </div>
    

  );
}

const styles = {

  container: {
    maxWidth: "1000px",
    margin: "10px auto 40px",
    fontFamily: "sans-serif",
    padding: "20px",
    borderRadius: "10px",
  },


  spinner_box: { 
    position: "relative", 
    width: "100%", 
    height: "100%", 
  }, 

  spinner_outer: { 
    position: "absolute", 
    top: "50%", 
    left: "50%", 
    transform: "translate(-50%, -50%)", 
  },

  spinner: { 
    position: "relative", 
    width: "50px", 
    height: "50px", 
  }, 

  spinner_inner: {
    position: "absolute", 
    top: "50%", 
    left: "50%", 
    transform: "translate(-50%, -50%)", 
  }, 
  

  banner: {
    position: "fixed",
    bottom: "200px",
    left: "50%",            // 画面の真ん中に配置
    transform: "translateX(-50%)", // 自分の幅の半分だけ左に戻す（これで完全に中央！）
    width: "90%",           // 基本は画面幅の90%
    maxWidth: "500px",      // でも500px以上には大きくならない
    color: "#fff",
    background: "rgba(30,30,30,0.9)",
    backdropFilter: "blur(4px)",
    borderRadius: "10px",
    padding: "12px 16px",
    zIndex: 1000,
},

  bannerBtns: {
    marginTop:"10px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },

  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 2000,
  },

  modal: {
    background: "#fff",
    padding: "24px",
    borderRadius: "12px",
    width: "320px",
    textAlign: "center",
    boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
  },

  primaryButton: {
    background: "#4CAF50",
    color: "#fff",
    border: "none",
    padding: "10px 16px",
    borderRadius: "6px",
    cursor: "pointer",
    marginRight: "8px",
  },

  secondaryButton: {
    background: "#eee",
    border: "none",
    padding: "10px 16px",
    borderRadius: "6px",
    cursor: "pointer",
  },

  linkButton: {
    background: "transparent",
    color: "#aaa",
    border: "none",
    marginRight: "8px",
    cursor: "pointer",
  },
};
